import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { WarehouseCrumbs } from "./-crumbs";
import WarehouseCreateForm from "./-form";

export const Route = createFileRoute(
  "/_private/_warehouse-360/warehouse/create",
)({
  component: WarehouseCreatePage,
});

function WarehouseCreatePage() {
  return (
    <div>
      <title>Create Warehouse - Legrande Health Portal</title>
      <WarehouseCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Create Warehouse</CardTitle>
          <CardDescription>Enter warehouse item details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <WarehouseCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
